
































































import {
  SfCarousel, SfProductCard, SfProductCardSkeleton, SfCarouselItem,
} from '~/components/StorefrontUi';
import {
  defineComponent, toRefs, PropType, computed, useContext,
} from '@nuxtjs/composition-api';

import useWishlist from '~/modules/wishlist/composables/useWishlist';

import { useAddToCart } from '~/helpers/cart/addToCart';
import { useAmastyFreeGifts } from '~/modules/checkout/composables/useAmastyFreeGifts';

import { useProductsWithCommonProductCardProps } from '~/modules/catalog/category/components/views/useProductsWithCommonCardProps';
import type { Product } from '~/modules/catalog/product/types';
import type { Aggregation } from '@vue-storefront/magento-types';
import type { ProductStrategy } from '~/modules/catalog/product/components/ProductSliderSection.vue';

export default defineComponent({
  name: 'ProductSlider',
  components: {
    SfProductCardSkeleton,
    SfProductCard,
    SfCarousel,
    SfCarouselItem,
  },
  props: {
    products: {
      type: Array as PropType<Product[]>,
      required: true,
    },
    aggregations: {
      type: Array as PropType<Aggregation[]>,
      required: true,
    },
    loading: Boolean,
    list: {
      type: String as PropType<string>,
      default: '',
    },
    productStrategy: {
      type: String as PropType<ProductStrategy>,
      default: 'product',
    },
  },
  setup(props) {
    const { addOrRemoveItem } = useWishlist();
    const { addItemToCart } = useAddToCart();
    const { products, aggregations } = toRefs(props);
    const { app } = useContext();
    const { addGiftToCart } = useAmastyFreeGifts();
    const { productsWithCommonProductCardProps } = useProductsWithCommonProductCardProps({
      products,
      aggregations,
    });

    const addItemToWishlist = async (product) => {
      await addOrRemoveItem({ product, list: 'Product Slider' });
    };
    const isGift = computed(() => props.productStrategy === 'gift');

    const addToCartHandler = async (product) => {
      if (props.productStrategy === 'gift') {
        addGiftToCart(app.$vsf.$magento.config.state.getCartId(), product.sku);
      } else if (props.productStrategy === 'product') {
        await addItemToCart({
          product,
          quantity: product.commonProps.qtyConfig.min_sale_qty,
          attributes: aggregations.value,
        });
      }
    };

    return {
      addItemToCart,
      addItemToWishlist,
      productsWithCommonProductCardProps,
      isGift,
      addToCartHandler,
    };
  },
});
